import React, { useState, useEffect } from 'react';
import { icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { downloadPDF } from '../../helpers/helperFunctions';

const Manuals = (props) => {
	const { i18n, t } = useTranslation();
    const [manualList, setManualList] = useState([])
    const [warrantyList, setWarrantyList] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
       //getManuals()
        getData()
    }, [])


    useEffect(() => {
		// This function will be called whenever the language changes
		const onLanguageChanged = () => {
            //getManuals()
            getData()
		//   getEventsPost(currentPage, currentFilter, currentTypes, currentDevices)

		  // You can perform other actions here when the language changes
		};
	
		// Register the event listener for language changes
		i18n.on('languageChanged', onLanguageChanged);
	
		// Cleanup function to remove the event listener
		return () => {
		  i18n.off('languageChanged', onLanguageChanged);
		};
	  }, [i18n]); // Dependency array to ensure effect is set up correctly


    // const getManuals = () => {
    //     let lang = localStorage.getItem("language")
    //     request.post("", "services/vehiclemanuals", {language: lang ? lang : "en"}).then((response) => {
    //        setManualList(response.data.manuals)
    //        setLoading(false)
    //     })  
    // }

    const getData = async() => {
        try{
            const lang = localStorage.getItem("language")
            const warranties = await request.post("", "services/warranty", {language: lang ? lang : "en"})
            const manuals = await request.post("", "services/vehiclemanuals", {language: lang ? lang : "en"})
            setWarrantyList(warranties.data.warranty)
            setManualList(manuals.data.manuals)

        }catch{
            
        }finally{
            setLoading(false)
        }
    }
    
    return(
        <>
        <p className="mb-1 bold">{t("settings.user_manuals")}</p>

            {manualList && manualList.map((manual, index) => (
                manual.pdfurl !== null &&
                <div key={index}>
                    <p className="mb-1 bold mt-3">{manual?.productname}</p>
                        <div className="d-flex flex-column settings-radius">
                            <div className={`p-3 d-flex justify-content-between align-items-center bg-white ${index < manualList.length-1 ? /*"border-settings"*/ "" : ""}`}>
                                <h4 className="regular">{t("manuals.user_manual")}</h4>
                                <img className="size_15 cursor-pointer" src={icons.download} alt={""} onClick={() => downloadPDF(manual.pdfurl)}/>
                            </div>
                        </div>
                    </div>
            ))}

        {/* <div className="d-flex flex-column settings-radius">
            {manualList && manualList.map((manual, index) => (
                manual.pdfurl !== null &&
                <div key={index} className={`p-3 d-flex justify-content-between align-items-center bg-white ${index < manualList.length-1 ? "border-settings" : ""}`}>
                    <h4 className="regular">{manual.productname}</h4>
                    <img className="size_15 cursor-pointer" src={icons.download} alt={""} onClick={() => downloadPDF(manual.pdfurl)}/>
                </div>
            ))}
        </div> */}
        {manualList && manualList.length === 0 && !loading &&
            <div className="p-3 w-100">
                <h3 className="regular text-center">{t("settings.no_manuals_found")}</h3>
            </div>
        }
        </>
    )
}

export default Manuals;